import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
  UserPoolId: "us-west-2_z5QOW5Ya4",
  ClientId: "38g5rdn1l850mcahd51125fjqn"
}

export default new CognitoUserPool(poolData);